export const strategicDocumentsData = {
  Romania: [
    {
      countryRegion: 'Romania',
      localTitle: 'Strategia Națională privind Economia Circulară (2022)',
      englishTitle: 'National Strategy for Circular Economy (2022)',
      link:
        'https://www.mmediu.ro/app/webroot/uploads/files/Strategia%20Nationala%20privind%20Economia%20Circulara%20-%20var%20finala.pdf'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Planul de acțiune pentru Strategia națională privind economia circulară (2023)',
      englishTitle: 'Action Plan for the National Circular Economy Strategy (2023)',
      link:
        'https://circulareconomy.europa.eu/platform/sites/default/files/2023-10/planul_naional_de_aciune_privind_economia_circulara.pdf'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Planul Național de Gestionare a Deșeurilor (PNGD) – aprobat prin HG nr. 942/2017 (publicat 2018)',
      englishTitle: 'National Waste Management Plan (PNGD) – adopted by GD no. 942/2017 (published 2018)',
      link: 'https://mmediu.ro/en/domenii/mediu/deseuri/documente-de-planificare-pngd-pjgd/'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Programul Național de Prevenire a Generării Deșeurilor (PNPGD) (inclus în PNGD)',
      englishTitle: 'National Waste Prevention Programme (included in PNGD)',
      link: 'https://mmediu.ro/en/domenii/mediu/deseuri/documente-de-planificare-pngd-pjgd/'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Strategia Națională pentru Dezvoltarea Durabilă a României 2030 (HG nr. 877/2018)',
      englishTitle: 'National Strategy for Sustainable Development of Romania 2030 (GD no. 877/2018)',
      link:
        'https://romania-durabila.gov.ro/wp-content/uploads/2020/05/strategia-nationala-pentru-dezvoltarea-durabila-a-romaniei-2030.pdf'
    },
    {
      countryRegion: 'Romania',
      localTitle:
        'Planul național de acțiune pentru implementarea Strategiei naționale pentru dezvoltarea durabilă a României 2030 (2022–2030)',
      englishTitle: 'National Action Plan for implementing Romania’s Sustainable Development Strategy 2030 (2022–2030)',
      link: 'https://romania-durabila.gov.ro/wp-content/uploads/2023/12/PNA-SNDDR-2030_En.pdf'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Strategia națională de cercetare, inovare și specializare inteligentă 2022–2027 (HG nr. 933/2022)',
      englishTitle: 'National Strategy for Research, Innovation and Smart Specialisation 2022–2027 (GD no. 933/2022)',
      link:
        'https://www.research.gov.ro/programe-nationale/strategia-nationala-de-cercetare-inovare-si-specializare-inteligenta-2022-2027/'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Strategia Națională privind Agenda Digitală pentru România 2020 (aprobată 2015)',
      englishTitle: 'National Strategy on the Digital Agenda for Romania 2020 (approved 2015)',
      link:
        'https://www.ancom.ro/uploads/links_files/Strategia_nationala_privind_Agenda_Digitala_pentru_Romania_2020.pdf'
    },
    {
      countryRegion: 'Romania',
      localTitle:
        'Planul național integrat în domeniul energiei și schimbărilor climatice 2021–2030 (actualizat, transmis 2024)',
      englishTitle: 'Integrated National Energy and Climate Plan (NECP) 2021–2030 (final updated, submitted 2024)',
      link: 'https://commission.europa.eu/publications/romania-final-updated-necp-2021-2030-submitted-2024_en'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Planul de redresare și reziliență al României (PNRR)',
      englishTitle: 'Romania’s Recovery and Resilience Plan (NRRP/PNRR)',
      link:
        'https://commission.europa.eu/business-economy-euro/economic-recovery/recovery-and-resilience-facility/country-pages/romanias-recovery-and-resilience-plan_en'
    }
  ],
  Moldova: [
    {
      countryRegion: 'Republic of Moldova',
      localTitle: 'Strategia Națională de Dezvoltare ’Moldova Europeană 2030’',
      englishTitle: 'National Development Strategy ’European Moldova 2030’',
      link:
        'https://mded.gov.md/?s=Strategia+Na%C8%9Bional%C4%83+de+Dezvoltare+%E2%80%9EMoldova+European%C4%83+2030%E2%80%9D'
    },
    {
      countryRegion: 'Republic of Moldova',
      localTitle: 'Strategia Națională de Dezvoltare Economică 2030',
      englishTitle: 'National Economic Development Strategy 2030',
      link: 'https://mded.gov.md'
    },
    {
      countryRegion: 'Republic of Moldova',
      localTitle: 'Programul pentru promovarea economiei verzi și circulare 2024–2028',
      englishTitle: 'Programme for Promoting Green and Circular Economy 2024–2028',
      link: 'https://climate-laws.org/'
    },
    {
      countryRegion: 'Republic of Moldova',
      localTitle: 'Strategia de Mediu 2014–2023',
      englishTitle: 'Environmental Strategy 2014–2023',
      link: 'https://www.unep.org/resources/report/environmental-strategy-years-2014-2023'
    }
  ],
  Germany: [
    {
      countryRegion: 'Germany',
      localTitle: 'Nationale Kreislaufwirtschaftsstrategie (NKWS) 2024',
      englishTitle: 'National Circular Economy Strategy 2024',
      link: 'https://www.bundesumweltministerium.de/en/topics/circular-economy/circular-economy-strategy'
    },
    {
      countryRegion: 'Germany',
      localTitle: 'Deutsches Ressourceneffizienzprogramm III (ProgRess III, 2020–2023)',
      englishTitle: 'German Resource Efficiency Programme III (ProgRess III)',
      link: 'https://www.bmuv.de/WS1672-1'
    },
    {
      countryRegion: 'Germany',
      localTitle: 'Nationales Abfallvermeidungsprogramm (2021)',
      englishTitle: 'National Waste Prevention Programme (2021 update)',
      link: 'https://www.bmuv.de/PU553-1'
    },
    {
      countryRegion: 'Germany',
      localTitle: 'Deutsche Rohstoffstrategie (2020)',
      englishTitle: 'German Raw Materials Strategy (2020)',
      link: 'https://www.bmwk.de/Redaktion/EN/Publikationen/raw-materials-strategy-2020.html'
    },
    {
      countryRegion: 'Baden-Württemberg (Germany)',
      localTitle: 'Landesstrategie Ressourceneffizienz (Fortschreibung 2024)',
      englishTitle: 'State Resource Efficiency Strategy (updated 2024)',
      link:
        'https://um.baden-wuerttemberg.de/de/umwelt-natur/umwelt-und-wirtschaft/ressourceneffizienz-und-greentech/landesstrategie-ressourceneffizienz'
    }
  ],
  Croatia: [
    {
      countryRegion: 'Croatia/',
      localTitle: 'Nacionalna razvojna strategija Republike Hrvatske do 2030. (NRS 2030)',
      englishTitle: 'National Development Strategy of the Republic of Croatia until 2030',
      link: 'https://hrvatska2030.hr/'
    },
    {
      countryRegion: 'Croatia/',
      localTitle: 'Strategija pametne specijalizacije do 2029',
      englishTitle: 'Smart Specialisation Strategy of the Republic of Croatia 2021–2029',
      link: 'https://mingo.gov.hr/UserDocsImages/slike/Vijesti/2022/S3%20do%202029%20Tekst%20VRH%202023%2012%2013.pdf'
    },
    {
      countryRegion: 'Croatia/',
      localTitle: 'Plan za oporavak i otpornost Republike Hrvatske 2021–2026. (NPOO)',
      englishTitle: 'National Recovery and Resilience Plan of the Republic of Croatia 2021–2026',
      link:
        'https://planoporavka.gov.hr/UserDocsImages/dokumenti/Plan%20oporavka%20i%20otpornosti%2C%20srpanj%202021..pdf?vel=13435491'
    },
    {
      countryRegion: 'Croatia/',
      localTitle: 'Strategija gospodarenja otpadom Republike Hrvatske',
      englishTitle: 'Waste Management Strategy of the Republic of Croatia',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2005_11_130_2398.html'
    },
    {
      countryRegion: 'Croatia/',
      localTitle: 'Strategija digitalne Hrvatske / Digitalna Hrvatska 2032',
      englishTitle: 'Digital Croatia 2032 Strategy',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2023_01_2_17.html'
    },
    {
      countryRegion: 'Croatia/',
      localTitle: 'Integrirani nacionalni energetski i klimatski plan Republike Hrvatske (NECP)',
      englishTitle: 'Integrated National Energy and Climate Plan of the Republic of Croatia',
      link:
        'https://mzozt.gov.hr/azurirani-integrirani-nacionalni-energetski-i-klimatski-plan-republike-hrvatske-za-razdoblje-od-2021-2030-necp/9220'
    }
  ],
  Austria: [
    {
      countryRegion: 'Austria',
      localTitle: 'Kreislaufwirtschaftsprofil 2024 – Österreich',
      englishTitle: 'Circular economy country profile 2024 - Austria',
      link:
        'https://www.eea.europa.eu/en/topics/in-depth/circular-economy/country-profiles-on-circular-economy/circular-economy-country-profiles-2024/austria_2024-ce-country-profile_final.pdf/@@download/file'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'STRAT.AT 2020-Partnerschaft ’Smart Specialisation’',
      englishTitle: 'STRAT.AT 2020 Partnership ’Smart Specialisation’',
      link:
        'https://www.oerok.gv.at/region/eu-fonds-2014-2020/partnerschaftsvereinbarung/begleitprozess/partnerschaft-smart-specialisation#:~:text=Einrichtung%20und%20Aufgabe%20der%20Partnerschaft'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'Strategie ’Digitale Kompetenzen Österreich’',
      englishTitle: 'Strategy ’Digital Competences Austria’',
      link: 'https://www.digitalaustria.gv.at/kompetenzen/strategien.html'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'Digitaler Aktionsplan Austria',
      englishTitle: 'Digital Action Plan Austria',
      link: 'https://www.digitalaustria.gv.at/verwaltung/strategien/digitaler-aktionsplan.html'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'Österreichische Kreislauftwirtschaftsstrategie',
      englishTitle: 'Austrian circular economy strategy',
      link:
        'https://www.bmluk.gv.at/dam/jcr%3Abaacfdef-c63e-49f5-ab8f-e4be8c0d7504/Kreislaufwirtschaftsstrategie_2022_230215.pdf'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'Digital Austria Act',
      englishTitle: 'Digital Austria Act',
      link: 'https://www.digitalaustria.gv.at/verwaltung/strategien/daa.html'
    }
  ],
  Slovenia: [
    {
      countryRegion: 'Slovenia',
      localTitle: 'Ekonomske raziskave OECD Slovenija',
      englishTitle: 'OECD Economic Surveys Slovenia',
      link:
        'https://www.oecd.org/content/dam/oecd/en/publications/reports/2024/07/oecd-economic-surveys-slovenia-2024_37e8dc60/bc4a107b-en.pdf'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Evropska gospodarska napoved jesen 2025',
      englishTitle: 'European Economic Forecast Autumn 2025',
      link:
        'https://economy-finance.ec.europa.eu/document/download/34538512-fff6-451a-8bbc-4c8d60e4d132_en?filename=ip327_en.pdf'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Delovni dokument služb Komisije Poročilo o državi za leto 2024 – Slovenija',
      englishTitle: 'Commission staff working document 2024 country report – Slovenia',
      link:
        'https://economy-finance.ec.europa.eu/document/download/237bde97-bc2e-4577-854d-f4c4c4ca5912_en?filename=SWD_2024_624_1_EN_Slovenia.pdf'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Regionalni pregled OECD 2023: Slovenija',
      englishTitle: 'OECD Regional Outlook 2023: Slovenia',
      link:
        'https://www.oecd.org/content/dam/oecd/en/publications/reports/2024/12/oecd-regional-outlook-2023-country-notes_48701f02/slovenia_12aed570/64230c9c-en.pdf'
    },
    {
      countryRegion: 'Slovenia',
      localTitle:
        'Posvetovanje o členu IV za leto 2024 – sporočilo za javnost; poročilo osebja; in izjava izvršnega direktorja za Republiko Slovenijo',
      englishTitle:
        'Republic of Slovenia 2024 article IV consultation—Press release; staff report; and statement by the executive director for the Republic of Slovenia',
      link: 'https://www.imf.org/-/media/files/publications/cr/2024/english/1svnea2024001.pdf'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Strategija razvoja Slovenije 2030',
      englishTitle: 'Slovenian Development Strategy 2030',
      link:
        'https://www.gov.si/assets/ministrstva/MKRR/Strategija-razvoja-Slovenije-2030/Slovenian-Development-Strategy-2030.pdf'
    }
  ],
  Bulgaria: [
    {
      countryRegion: 'Bulgaria',
      localTitle: 'Национална стратегия за МПС 2021-2027',
      englishTitle: 'National Strategy for Small and Medium-sized Enterprises 2021-2027',
      link:
        'https://www.mi.government.bg/en/strategy-policy/national-strategy-for-small-and-medium-sized-enterprises-smes-in-bulgaria-2021-2027/'
    },
    {
      countryRegion: 'Bulgaria',
      localTitle:
        'Актуализирана Национална стратегия за малките и средните предприятия 2021-2027 г. с удължен срок на действие до 2030 г.',
      englishTitle:
        'National Strategy for small and medium-sized еnterprises 2021–2027, with an extended Implementation period until 2030',
      link: 'https://www.strategy.bg/bg/strategy-documents/1730'
    },
    {
      countryRegion: 'Bulgaria',
      localTitle: 'Национална програма за развитие',
      englishTitle: 'National Development Programme',
      link: 'https://www.strategy.bg/bg/strategy-documents/1349'
    },
    {
      countryRegion: 'Bulgaria',
      localTitle: 'Национален стратегически документ ’Цифрова трансформация на България за периода 2020-2030 г.’',
      englishTitle: 'National strategic document ’Digital Transformation of Bulgaria for the period 2020-2030’',
      link:
        'https://www.mtc.government.bg/en/category/283/national-strategic-document-digital-transformation-bulgaria-period-2020-2030-0'
    }
  ],
  Czechia: [
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Národní výzkumná a inovační\nstrategie pro inteligentní\nspecializaci ČR 2021–2027',
      englishTitle:
        'National Research and Innovation\nStrategy for Smart Specialisation\nof the Czech Republic 2021–2027',
      link: 'https://ris3.gov.cz/sites/default/files/National-RIS3-Strategy_2.pdf'
    },
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Cesta k evropské digitální dekádě: Strategický plán digitalizace Česka do roku 2030',
      englishTitle:
        'The Path to Europe’s\nDigital Decade: The\nStrategic Plan for the\nDigitalization of\nCzechia by 2030',
      link:
        'https://digitalnicesko.gov.cz/media/files/The_Path_to_Europes_Digital_Decade_The_Strategic_Plan_for_the_Digitalization_of_Czechia_by_2030_oOROu6I.pdf'
    },
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Národní strategie\numělé inteligence\nČeské republiky 2030',
      englishTitle: 'National Strategy for Artificial Intelligence of the Czech Republic 2030',
      link: 'https://mpo.gov.cz/assets/cz/rozcestnik/pro-media/tiskove-zpravy/2019/6/NAIS_eng_korektura_06-19_web.pdf'
    },
    {
      countryRegion: 'Czech Reublic/Prague',
      localTitle: 'Cirkulární Praha 2030- Pražská strategie přechodu na cirkulární ekonomiku III',
      englishTitle: 'Circular Prague 2030',
      link: 'https://klima.praha.eu/data/Dokumenty/circular-prague-2030-eng.pdf'
    },
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Aktualizovaný strategický rámec Česká republika 2030 s výhledem do roku 2050',
      englishTitle: 'Updated Strategic Framework\nCzech Republic 2030\nwith Outlook to 2050',
      link: 'https://www.cr2030.cz/system/files/2025-05/updated%20strategic%20framework%20CZ%202030.pdf'
    },
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Cirkulární Česko',
      englishTitle: 'Circular Czechia',
      link: 'https://incien.org/wp-content/uploads/2021/06/circular_czechia.pdf'
    },
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Strategie pro rovnost žen a mužů 2021-2030',
      englishTitle: 'Gender Equality Strategy 2021–2030',
      link: 'https://vlada.gov.cz/assets/ppov/gcfge/Updated-Gender-Equality-Strategy-2021-2030---Condensed-Version.pdf'
    },
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Státní politika životního prostředí České republiky 2030 s výhledem na 2050',
      englishTitle: 'State Environmental Policy of the Czech Republic 2030 with outlook to 2050',
      link: 'https://mzp.gov.cz/system/files/2024-07/OPZPUR-SEP_2030_EN-20220525.pdf'
    },
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Inovační strategie České republiky 2019–203',
      englishTitle: 'Innovation Strategy\nof the Czech Republic\n2019—2030',
      link: 'https://vyzkum.gov.cz/FrontClanek.aspx?idsekce=867922'
    },
    {
      countryRegion: 'Czech Republic',
      localTitle: 'Strategie podpory malých a středních podniků v České republice na období 2021–2027',
      englishTitle: 'Strategy to support small and medium-sized enterprises in the Czech republic 2021–2027',
      link:
        'https://www.czechia.eu/wp-content/uploads/2021/12/Strategy-to-support-SMEs-in-the-Czech-Republic-2021-2027.pdf'
    }
  ],
  'Slovak republic': [
    {
      countryRegion: 'Slovakia',
      localTitle: 'NÁRODNÝ AKČNÝ PLÁN ZAMESTNANOSTI ŽIEN NA ROKY 2022 - 2030',
      englishTitle: 'National Action Plan for Women’s Employment 2022-2030',
      link:
        'https://www.employment.gov.sk/files/sk/ministerstvo/spolocny-sekretariat-vyborov/vybor-rodovu-rovnost/dokumenty-udalosti/nap_zamestnanosti_zien_22-30.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle:
        'CELOŠTÁTNA STRATÉGIA ROVNOSTI ŽIEN A MUŽOV A ROVNOSTI PRÍLEŽITOSTÍ V SLOVENSKEJ REPUBLIKE NA ROKY 2021-2027',
      englishTitle:
        'National Strategy for Equality between Women and Men and Equal Opportunities in the Slovak Republic for 2021-2027',
      link:
        'https://www.employment.gov.sk/files/sk/ministerstvo/spolocny-sekretariat-vyborov/vybor-rodovu-rovnost/dokumenty-udalosti/strategia-rovnosti-z-m-2021-27.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Zelenšie Slovensko: STRATÉGIA ENVIRONMENTÁLNEJ POLITIKY\nSLOVENSKEJ REPUBLIKY DO ROKU 2030',
      englishTitle: 'Greener Slovakia: Strategy of the Environmental Policy of the\nSlovak Republic until 2030',
      link:
        'https://www.minzp.sk/files/iep/greener_slovakia-strategy_of_the_environmental_policy_of_the_slovak_republic_until_2030.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Nízkouhlíková stratégia rozvoja Slovenskej republiky do roku 2030 s výhľadom do roku 2050',
      englishTitle: 'Low-Carbon Development Strategy of the Slovak Republic until 2030 with a View to 2050',
      link: 'https://ec.europa.eu/clima/sites/lts/lts_sk_sk.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Revízia a aktualizácia národnej stratégie adaptácie na zmenu klímy na Slovensku',
      englishTitle: 'Revision and update of the national strategy on adaptation to climate change in Slovakia',
      link:
        'https://www.klima-adapt.sk/dokument/f/revision-and-update-of-the-national-strategy-on-adaptation-to-climate-change-in-slovakia.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Aktualizácia integrovaného národného energetického a klimatického plánu na roky 2021 - 2030',
      englishTitle: 'Draft update of the Integrated National energy and climate plan for 2021-2030',
      link:
        'https://commission.europa.eu/document/download/4f373d12-ce73-403a-a2d5-0107bf3e0c24_en?filename=SLOVAKIA%20-%20DRAFT%20UPDATED%20NECP%202021-2030_EN.pdf\nin SK: https://www.mhsr.sk/uploads/files/A65vdZlY.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Program predchádzania vzniku odpadu Slovenskej republiky na roky 2019 – 2025',
      englishTitle: 'Waste prevention programme of the Slovak Republic for the years 2019-2025',
      link:
        'https://www.minzp.sk/files/sekcia-enviromentalneho-hodnotenia-riadenia/odpady-a-obaly/registre-a-zoznamy/ppvo-sr-19-25.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Program odpadového hospodárstva SR na roky 2021– 2025',
      englishTitle: 'Waste Management Programme of the Slovak Republic for 2021- 2025',
      link:
        'https://minzp.sk/files/sekcia-enviromentalneho-hodnotenia-riadenia/odpady-a-obaly/registre-a-zoznamy/poh_sr_2021_2025_vestnik.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Návrh Vízie a stratégie rozvoja Slovenska do roku 2030 - dlhodobá stratégia udržateľného rozvoja',
      englishTitle:
        'Draft Vision and Development Strategy of Slovakia until 2030 - long-term sustainable development strategy',
      link: 'https://mirri.gov.sk/wp-content/uploads/2021/01/SLOVENSKO-2030.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Vízia a stratégia rozvoja Slovenska 2030 -\nPodklady pre dlhodobé strategické plánovanie',
      englishTitle: 'Vision and development strategy of Slovakia 2030 - Background for a long-term strategic planning',
      link:
        'https://unece.org/sites/default/files/2023-03/WP.3_4_Slovakia_Vision%20and%20Development%20Strategy%20of%20Slovakia%202030_cj.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Návrh Stratégie hospodárskej politiky Slovenskej republiky do roku 2030',
      englishTitle: 'Draft Economic Policy Strategy of the Slovak Republic until 2030',
      link: 'https://www.mhsr.sk/uploads/files/T3H3k8da.pdf?csrt=13659438263639711875'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Stratégia digitálnej transformácie Slovenska 2030',
      englishTitle: '2030 Digital Transformation Strategy for Slovakia',
      link: 'https://mirri.gov.sk/wp-content/uploads/2019/10/SDT-English-Version-FINAL.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Akčný plán digitálnej transformácie Slovenska na roky 2023 – 2026',
      englishTitle: 'Action Plan for the Digital Transformation of Slovakia for 2023-2026',
      link: 'https://mirri.gov.sk/wp-content/uploads/2023/01/APDTS-2023-2026.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'NÁRODNÁ STRATÉGIA DIGITÁLNYCH ZRUČNOSTÍ SLOVENSKEJ REPUBLIKY A AKČNÝ PLÁN NA ROKY 2023 – 2026',
      englishTitle:
        'THE NATIONAL DIGITAL SKILLS STRATEGY OF THE SLOVAK REPUBLIC AND THE ACTION PLAN FOR THE YEARS 2023 - 2026',
      link:
        'https://digitalnakoalicia.sk/wp-content/uploads/2023/08/THE-NATIONAL-DIGITAL-SKILLS-STRATEGY-OF-THE-SLOVAK-REPUBLIC-AND-THE-ACTION-PLAN-FOR-THE-YEARS-2023-2026.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'STRATÉGIA A AKČNÝ PLÁN NA ZLEPŠENIE POSTAVENIA SLOVENSKA V INDEXE DESI DO ROKU 2025',
      englishTitle: 'STRATEGY AND ACTION PLAN\nTO IMPROVE SLOVAKIA’S POSITION IN THE DESI INDEX\nBY 2025',
      link:
        'https://digitalnakoalicia.sk/wp-content/uploads/2023/08/STRATEGY-AND-ACTION-PLAN-TO-IMPROVE-SLOVAKIAS-POSITION-IN-THE-DESI-INDEX-BY-2025.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'NÁVRH STRATÉGIE VÝSKUMU A INOVÁCIÍ PRE INTELIGENTNÚ ŠPECIALIZÁCIU SLOVENSKEJ REPUBLIKY 2021 - 2027',
      englishTitle: 'DRAFT RESEARCH AND INNOVATION STRATEGY FOR SMART SPECIALISATION OF THE SLOVAK REPUBLIC 2021-2027',
      link:
        'https://mirri.gov.sk/wp-content/uploads/2018/10/Research-and-innovation-strategy-for-smart-specialisation-of-the-Slovak-Republic-2021-2027.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Národná stratégia výskumu, vývoja a inovácií 2030',
      englishTitle: 'National Strategy for Research, Development and Innovation 2030',
      link:
        'https://vaia.gov.sk/wp-content/uploads/2025/05/National-Strategy-for-research-development-and-innovation-2030.pdf'
    }
  ],
  Serbia: [
    {
      countryRegion: 'Republic of Serbia',
      localTitle: 'Nacionalna strategija za rodnu ravnopravnost za period od 2021-2030',
      englishTitle: 'The Gender Equality Strategy for the Period 2021-2030',
      link: 'https://www.rodnaravnopravnost.gov.rs/sites/default/files/2022-03/National Strategy for GE 2021-2030.pdf'
    },
    {
      countryRegion: 'Republic of Serbia',
      localTitle: 'Strategija niskougljeničnog razvoja Republike Srbije za period od 2023. do 2030.',
      englishTitle: 'Low-Carbon Development Strategy for 2023–2031',
      link:
        'https://www.ekologija.gov.rs/sites/default/files/2023-11/low_carbon_development_strategy_of_the_republic_of_serbia_for_the_period_2023-_2030_with_projections_until_2050.pdf'
    },
    {
      countryRegion: 'Republic of Serbia',
      localTitle: 'Program upravljanja otpadom u Republici Srbiji za period 2022-2031. godine',
      englishTitle: 'Waste Management Programme for 2022–2031',
      link:
        'https://www.ekologija.gov.rs/sites/default/files/2022-03/program_upravljanja_otpadom_eng_-_adopted_version.pdf'
    },
    {
      countryRegion: 'Republic of Serbia',
      localTitle: 'Program razvoja cirkularne ekonomije u Republici Srbiji za period 2022–2024. godine',
      englishTitle:
        'Program for Development of Circular Economy in the Republic of Serbia for the period 2022-2024 year',
      link:
        'https://www.ekologija.gov.rs/sites/default/files/2022-12/program_razvoja_cirkularne_ekonomije_u_republici_srbiji_za_period_2022-2024._godine__0.pdf'
    },
    {
      countryRegion: 'Republic of Serbia',
      localTitle: 'Mapa puta za cirkularnu ekonomiju u Srbiji',
      englishTitle: 'ROADMAP for circular economy in Serbia',
      link: 'https://circulareconomy.europa.eu/platform/sites/default/files/roadmap-for-circular-economy-in-serbia.pdf'
    },
    {
      countryRegion: 'Republic of Serbia',
      localTitle: 'Nacionalna strategija održivog razvoja',
      englishTitle: 'The National Strategy for Sustainable Development',
      link: 'https://pravno-informacioni-sistem.rs/eli/rep/sgrs/vlada/strategija/2008/57/1/reg'
    },
    {
      countryRegion: 'Republic of Serbia',
      localTitle: 'Strategija za razvoj malih i srednjih preduzeća za period od 2023. do 2027.',
      englishTitle: 'Strategy for the Development of Small and Medium Enterprises 2023-2027',
      link:
        'https://privreda.gov.rs/lat/dokumenta/propisi/strategije/strategija-za-razvoj-malih-i-srednjih-preduzeca-za-period-od-2023-do-2027-godine'
    },
    {
      countryRegion: 'Republic of Serbia',
      localTitle: 'Strategija pametne specijalizacije u Republici Srbiji 2020-2027',
      englishTitle: 'Smart Specialisation Strategy of the Republic of Serbia 2020-2027',
      link:
        'https://pametnaspecijalizacija.mpn.gov.rs/wp-content/uploads/2021/06/Strategija-pametne-specijalizacije_EN_WEB.pdf'
    }
  ],
  'Bosnia and Herzegovina': [
    {
      countryRegion: 'Bosnia and Herzegovina (state)',
      localTitle: 'Okvir za ostvarivanje Ciljeva održivog razvoja u Bosni i Hercegovini',
      englishTitle: 'Framework for the Implementation of Sustainable Development Goals in Bosnia and Herzegovina',
      link: 'https://zamisli2030.ba/wp-content/uploads/2024/03/VNR2023_ENG_web.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina (state)',
      localTitle: 'UN Sustainable Development Cooperation Framework BiH 2021–2025',
      englishTitle: 'United Nations Sustainable Development Cooperation Framework BiH 2021–2025',
      link: 'https://bosniaherzegovina.un.org/sites/default/files/2022-08/2022%20UNSDCF_BiH_JWP%20final%20ENG.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina (state)',
      localTitle: 'Bosnia and Herzegovina Digital Development Country Profile',
      englishTitle: 'Bosnia and Herzegovina Digital Development Country Profile',
      link:
        'https://www.itu.int/en/ITU-D/Regional-Presence/Europe/Documents/Publications/2023/Digital%20Development%20Country%20Profile%20Bosnia%20and%20Herzegovina%20%5Bfinal-%20March%202023%5D.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina (state)',
      localTitle: 'BiH Circular Economy White Paper',
      englishTitle: 'Bosnia and Herzegovina Circular Economy White Paper',
      link: 'https://zelenaekonomija.komorabih.ba/wp-content/uploads/2023/10/White_Paper_Publication_28042022.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina (state)',
      localTitle: 'Strateški okvir institucija Bosne i Hercegovine do 2030. godine',
      englishTitle: 'Strategic Framework of Institutions of BiH to 2030',
      link: 'https://aposo.gov.ba/sadrzaj/uploads/Strateski-okvir-institucija-BiH_do_2030_WEB.pdf'
    },
    {
      countryRegion: 'Federation of Bosnia and Herzegovina (entity)',
      localTitle: 'Strategija razvoja Federacije BiH 2021–2027',
      englishTitle: 'Development Strategy of the Federation of Bosnia and Herzegovina 2021–2027',
      link:
        'https://parlamentfbih.gov.ba/v2/userfiles/file/Materijali%20u%20proceduri_2021/Strategija%20razvoja%20FBiH%202021-2027_bos.pdf'
    }
  ],
  Hungary: [
    {
      countryRegion: 'Hungary',
      localTitle: 'Kis- és Középvállalkozás-fejlesztési Stratégia (KKV Stratégia)',
      englishTitle: 'Small and Medium-sized Enterprise Development Strategy (SME Strategy)',
      link: 'https://kormany.hu/dokumentumtar/felulvizsgalt-kkv-strategia-2019-2030'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Digitális Jólét Program (DJP)',
      englishTitle: 'Digital Success Programme 2.0 (Digital Welfare Programme)',
      link: 'https://digitalisjoletprogram.hu/'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Nemzeti Intelligens Szakosodási Stratégia (S3)',
      englishTitle: 'Innovation & entrepreneurship /National Innovation Strategy',
      link: 'https://nkfih.gov.hu/english/national-smart-specialisation-strategy/s3-2021-2027'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Foglalkoztatáspolitikai Stratégia (különböző ciklusok)',
      englishTitle: 'Employment strategy',
      link: 'https://szocialisportal.hu/wp-content/uploads/2023/03/MNTFS2030.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Családpolitikai Akciótervek / Családvédelmi Akcióterv',
      englishTitle: 'Work-family reconciliation',
      link: 'https://njt.hu/jogszabaly/2019-1110-30-22\nhttps://www.csalad.hu/'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Nemzeti Fejlesztés 2030 – Országos Fejlesztési és Területfejlesztési Koncepció',
      englishTitle: 'National Development 2030 – National Development and Regional Development Concept',
      link: 'https://njt.hu/jogszabaly/2014-1-30-41'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Magyarország Helyreállítási és Ellenállóképességi Terve (RRF)',
      englishTitle: 'Recovery & resilience Plan of Hungary',
      link: 'https://ec.europa.eu/commission/presscorner/api/files/document/print/en/ip_21_2442/IP_21_2442_EN.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Magyarország Kutatási, Fejlesztési, Innovációs stratégiája',
      englishTitle: 'National Innovation Strategy 2021-2030 (Innovation Strategy of Hungary)',
      link:
        'https://nkfih.gov.hu/hivatalrol/hivatal-kiadvanyai/magyarorszag-kutatasi-fejlesztesi-innovacios-strategiaja-2021-2030'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Magyarország\nNemzeti Fenntartható Fejlődési\nKeretstratégiája\n2025-2036 (tervezet)',
      englishTitle: 'National Framework Strategy for Sustainable Development (draft version)',
      link: 'https://www.nfft.hu/documents/d/nfft/nffs2_2-0_skv_20240821-pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Magyarország versenyképességi stratégiája',
      englishTitle: 'Competitiveness Strategy 2024–2030',
      link: 'https://kormany.hu/dokumentumtar/magyarorszag-versenykepessegi-strategiaja-2024-2030'
    }
  ]
}
